// ABOUTME: SPEC-82 D-8 — the "has this browser played the film" record and the frame field built from it, on its own.
// ABOUTME: Split out of useIntroExperiment (review M3) so each unit stays under the function-size gate; behaviour is unchanged.

import { useCallback, useEffect, useRef } from 'react';
import { markIntroSeen } from '../state/visitMemory';
import { hasPlayedFilm, markFilmPlayed } from './filmPlayedMemory';

const NO_FRAME_EXTRAS = Object.freeze({});

/**
 * @param {object} p
 * @param {Readonly<Record<string, true>>} p.ux the readUiExperiment() map
 * @param {boolean} p.showIntro the film-on-screen state
 * @returns {{ frameExtras: () => object, afterIntroFinishedSent: () => void }}
 */
export default function useFilmRecord({ ux, showIntro }) {
  // Read at CALL time: `sendIntroFinished` is reached from closures bound before /api/config arrived (the config lands after first
  // render), and a stale `ux` there would drop `film_played` from a frame the backend is waiting for.
  const uxRef = useRef(ux);
  uxRef.current = ux;
  const filmToggleOn = useCallback(() => !!(uxRef.current.skip_intro_film || uxRef.current.tap_to_talk), []);
  const filmToggle = filmToggleOn();

  const frameExtras = useCallback(() => {
    if (!filmToggleOn() || hasPlayedFilm()) return NO_FRAME_EXTRAS;
    console.log('[SPEC-82][FILM] frame film_played=false');
    return { film_played: false };
  }, [filmToggleOn]);

  // skip_intro_film has no film end to write the record at: the released welcome is the moment.
  const afterIntroFinishedSent = useCallback(() => {
    if (filmToggleOn()) markIntroSeen();
  }, [filmToggleOn]);

  // The film being on screen is the only positive evidence that it was watched (D-8).
  useEffect(() => {
    if (filmToggle && showIntro) markFilmPlayed();
  }, [filmToggle, showIntro]);

  return { frameExtras, afterIntroFinishedSent };
}
